import { OpaqueToken } from '@angular/core';

export const TRACKING_CONFIG = new OpaqueToken('TrackingConfig');



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/app/@shared/tracking/tracking.config.ts